import { post } from "../../utils/Backend";
import { useH5Mock } from "../../global/GlobalMock";
import { mockListMessageConversations, mockMarkMessageConversationRead } from "./SpaceMessageCenterMock";
import type {
  ListMessageConversationsResult,
  MarkMessageConversationReadResult,
} from "./SpaceMessageCenterTypes";

const mock = useH5Mock && false;
const BASE = "/lark/app/messageCenter";

export const SpaceMessageCenterApi = {
  async listConversations(spaceId: string): Promise<ListMessageConversationsResult | string> {
    if (mock) {
      return mockListMessageConversations(spaceId);
    }
    return post<{ spaceId: string }, ListMessageConversationsResult>(`${BASE}/listConversations`, {
      spaceId,
    });
  },

  async markRead(
    spaceId: string,
    conversationKey: string,
    readUpToMessageId?: string | null
  ): Promise<MarkMessageConversationReadResult | string> {
    if (mock) {
      return mockMarkMessageConversationRead(conversationKey);
    }
    return post<
      { spaceId: string; conversationKey: string; readUpToMessageId?: string },
      MarkMessageConversationReadResult
    >(`${BASE}/markRead`, {
      spaceId,
      conversationKey,
      readUpToMessageId: readUpToMessageId ?? undefined,
    });
  },
};
